// @flow

import {
  FETCH_NOTES_FAILURE,
  FETCH_NOTES_REQUEST,
  FETCH_NOTES_SUCCESS,
  UPDATE_NOTE_SUCCESS,
  FETCH_PAST_NOTES_COUNT_REQUEST,
  FETCH_PAST_NOTES_COUNT_SUCCESS,
  CLEAR_NOTEBOOK_NOTES
} from '../actions/notebook'

const initialState : {
  items: Array<Object>,
  isFetching: boolean,
  totalNotesCount: number
} = {
  items: [],
  isFetching: false,
  pastNotesCount: 0,
  total: null,
  totalPages: null
}

export function notebook (state: Object = initialState, action: Object) : Object {
  switch (action.type) {

    case FETCH_NOTES_REQUEST:
      return Object.assign({}, state, {
        isFetching: true
      })

    case FETCH_NOTES_FAILURE:
      return Object.assign({}, state, {
        isFetching: false
      })

    case FETCH_NOTES_SUCCESS: {
      const newItems = [
        ...state.items,
        ...action.payload.notes
      ]

      return {
        ...state,
        items: newItems,
        isFetching: false,
        total: action.payload.total,
        totalPages: action.payload.totalPages
      }
    }

    case UPDATE_NOTE_SUCCESS:
      const newNotes = state.items.splice(0)
      const noteToUpdate = newNotes.find(note => note.id === action.id)

      // this action also called from activity card note, in which case this is a no-op
      if (noteToUpdate) {
        noteToUpdate.visibility = action.visibility
      }

      return Object.assign({}, state, {
        items: newNotes
      })

    case FETCH_PAST_NOTES_COUNT_REQUEST: {
      return {
        ...state,
        isFetching: true,
        pastNotesCount: null
      }
    }

    case FETCH_PAST_NOTES_COUNT_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        pastNotesCount: action.payload.pastNotesCount
      }
    }

    case CLEAR_NOTEBOOK_NOTES: {
      return {
        ...state,
        items: []
      }
    }

    default:
      return state
  }
}
